<template>
  <router-view />
</template>
<script>
export default {
  name: "systemSetup",
  data() {
    return {};
  }
};
</script>
<style lang="less">

</style>
